import fileSaver from 'file-saver';
import geometry from './geometry';
import classes from './classes';


const previewServices = {
  counter: 1,
  // set static stamps position on preview image
  createStaticStamp(stamp, photoSize, controlSideLength, imageDensity) {
    let top;
    let left;
    if (stamp.points[0] && (stamp.points[0].x !== null || stamp.points[0].y !== null) && stamp.position) {
      for (let i = 0; i < stamp.position.length; i += 1) {
        if (stamp.position[i] === 't') {
          top = 0 - (stamp.points[0].y / (4 / 3)) + 'px';
        } else if (stamp.position[i] === 'b') {
          top = photoSize.height - (stamp.points[0].y / (4 / 3)) + 'px';
        } else if (stamp.position[i] === 'm') {
          top = photoSize.height / 2 - (stamp.points[0].y / (4 / 3)) + 'px';
        } else if (stamp.position[i] === 'l') {
          left = 0 - (stamp.points[0].x / (4 / 3)) + 'px';
        } else if (stamp.position[i] === 'r') {
          left = 0 + photoSize.width - (stamp.points[0].x / (4 / 3)) + 'px';
        } else if (stamp.position[i] === 'c') {
          left = photoSize.width / 2 - (stamp.points[0].x / (4 / 3)) + 'px';
        }
      }
    }
    let staticOffset = {
      x: left.replace('px', ''),
      y: top.replace('px', '')
    };
    let controlScale = geometry.calculateScaleForControls(stamp.scale, controlSideLength);
    return {
      pivot_id: stamp.pivot_id,
      url: stamp.image[imageDensity],
      order: stamp.order,
      top,
      left,
      staticOffset,
      type: stamp.type,
      rotate: stamp.rotation,
      scale: stamp.scale,
      controlScale
    };
  },
  // set frame stamps position on preview image
  createFrameStamp(stamp, imageDensity) {
    let top;
    let bottom;
    if (stamp.position === 't') {
      top = 0;
    } else {
      bottom = 0;
      stamp.position = 'b';
    }
    return {
      url: stamp.image[imageDensity],
      order: stamp.order,
      top,
      bottom,
      position: stamp.position,
      type: stamp.type,
      pivot_id: stamp.pivot_id
    };
  },
  // set eyes/lips stamps positions on preview image
  initialLoadEyesAndLips(eyesOrLips, faceLandmarks, imageDensity) {
    let type = eyesOrLips.type;
    let eyesOrLipsObject = null;
    let L = 120;
    let scaleFactor;
    let rotateDegrees;
    let eyesPointsStamp;
    if (type === 'eyes') {
      eyesPointsStamp = new classes.Eyes({x: L / 4, y: L / 2}, {x: L * 3 / 4, y: L / 2});
    } else if (type === 'mouth') {
      eyesPointsStamp = new classes.Eyes({x: 0, y: L / 2}, {x: L, y: L / 2});
    }
    let eyesPointsPhoto = new classes.Eyes(faceLandmarks[type][0], faceLandmarks[type][1]);
    let photoCenterBetweenEyes;
    // fixme: this code waiting for backend NOSE detection
    if (faceLandmarks.nose && type === 'eyes') {
      photoCenterBetweenEyes = {
        x: faceLandmarks.nose.x,
        y: faceLandmarks.nose.y
      };
    } else {
      photoCenterBetweenEyes = {
        x: (eyesPointsPhoto.firstEye.x + eyesPointsPhoto.secondEye.x) / 2,
        y: (eyesPointsPhoto.firstEye.y + eyesPointsPhoto.secondEye.y) / 2,
      };
    }
    let stampCenterBetweenEyes = {
      x: (eyesPointsStamp.firstEye.x + eyesPointsStamp.secondEye.x) / 2,
      y: (eyesPointsStamp.firstEye.y + eyesPointsStamp.secondEye.y) / 2,
    };
    rotateDegrees = geometry.angleBetween2Lines(eyesPointsStamp.firstEye, eyesPointsStamp.secondEye, eyesPointsPhoto.firstEye, eyesPointsPhoto.secondEye);
    scaleFactor = geometry.calculateScaleFactorByTwoLines(eyesPointsStamp.firstEye, eyesPointsStamp.secondEye, eyesPointsPhoto.firstEye, eyesPointsPhoto.secondEye);
    let combineStampAndPhotoPoints = {};
    combineStampAndPhotoPoints.x = photoCenterBetweenEyes.x - stampCenterBetweenEyes.x;
    combineStampAndPhotoPoints.y = photoCenterBetweenEyes.y - stampCenterBetweenEyes.y;
    let initialCoordinates = {
      x: combineStampAndPhotoPoints.x,
      y: combineStampAndPhotoPoints.y
    };
    console.log('combineStampAndPhotoPoints ', combineStampAndPhotoPoints);
    eyesOrLipsObject = {
      type,
      leftTopStampPoint: combineStampAndPhotoPoints,
      coordinates: combineStampAndPhotoPoints,
      pivot_id: eyesOrLips.pivot_id,
      url: eyesOrLips.image[imageDensity],
      order: eyesOrLips.order,
      scale: scaleFactor,
      rotate: -(360 - rotateDegrees),
      initialRotation: 360 - rotateDegrees,
      initialScale: scaleFactor,
      initialCoordinates
    };
    console.warn('initialScale ', scaleFactor);
    return eyesOrLipsObject;
  },
  /**
   * function count range between left top and right bottom corner of stamp
   * @param1 object {x, y} with stamp offsets
   * @param2 stamp size, in our case stamps are square so you need to just pass number with length of one side
   * @param3 current scale of stamp
   * */
  // todo: crate method 'contains(x, y)'
  getStampsRange(offsets, stampSize, scale) {
    let scalePixelsSize = stampSize * scale - stampSize;
    let scalePixelsSizeFromCenter = scalePixelsSize / 2;
    let stampRangeX = {
      start: parseInt(offsets.x, 10) - parseInt(scalePixelsSizeFromCenter, 10),
      end: parseInt(offsets.x, 10) + parseInt(stampSize, 10) + parseInt(scalePixelsSizeFromCenter, 10)
    };
    let stampRangeY = {
      start: parseInt(offsets.y, 10) - parseInt(scalePixelsSizeFromCenter, 10),
      end: parseInt(offsets.y, 10) + parseInt(stampSize, 10) + parseInt(scalePixelsSizeFromCenter, 10)
    };
    return {
      rangeX: stampRangeX,
      rangeY: stampRangeY
    };
  },
  scalingAndRotating(currentControl, stampsRangesXY) {
    let angle;
    let scale;
    let startScalePosition = {
      x: currentControl.xPoint,
      y: currentControl.yPoint
    };
    if (currentControl.selected.id === 'south-west') {
      angle = geometry.angleBetween2Lines(startScalePosition, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {x: stampsRangesXY.maximumValue, y: stampsRangesXY.minimumValue});
      scale = geometry.calculateScaleFactorOnPreview(startScalePosition, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {x: stampsRangesXY.maximumValue, y: stampsRangesXY.minimumValue});
    } else if (currentControl.selected.id === 'south-east') {
      angle = geometry.angleBetween2Lines(startScalePosition, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {x: stampsRangesXY.minimumValue, y: stampsRangesXY.minimumValue});
      scale = geometry.calculateScaleFactorOnPreview(startScalePosition, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {x: stampsRangesXY.minimumValue, y: stampsRangesXY.minimumValue});
    } else if (currentControl.selected.id === 'north-west') {
      angle = geometry.angleBetween2Lines(startScalePosition, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {x: stampsRangesXY.maximumValue, y: stampsRangesXY.maximumValue});
      scale = geometry.calculateScaleFactorOnPreview(startScalePosition, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {x: stampsRangesXY.middleValue, y: stampsRangesXY.middleValue}, {
        x: stampsRangesXY.maximumValue,
        y: stampsRangesXY.maximumValue
      });
    } else if (currentControl.selected.id === 'north-east') {
      angle = geometry.angleBetween2Lines(startScalePosition, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {x: stampsRangesXY.minimumValue, y: stampsRangesXY.maximumValue});
      scale = geometry.calculateScaleFactorOnPreview(startScalePosition, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {
        x: stampsRangesXY.middleValue,
        y: stampsRangesXY.middleValue
      }, {x: stampsRangesXY.minimumValue, y: stampsRangesXY.maximumValue});
    }
    return {
      angle,
      scale
    };
  },
  stampStackPopUp(event, stamp, eventSelectStamp, scaleResizeAvailableIndex, eventX, eventY, initialStampSideLength, computedStamps, currentStampType, story, stampIndex) {
    // todo: rewrite function in small ones
    let that = this;
    const offsetConst = 1;
    if (eventSelectStamp === scaleResizeAvailableIndex) {
      if (event.pageX <= eventX + offsetConst && event.pageX >= eventX - offsetConst && event.pageY <= eventY + offsetConst && event.pageY >= eventY - offsetConst) {
        let mouseOffsetXWithScale = event.offsetX * stamp.scale;
        let mouseOffsetYWithScale = event.offsetY * stamp.scale;
        let stampOffsetX = event.target.offsetLeft - (initialStampSideLength * stamp.scale - initialStampSideLength) / 2;
        let stampOffsetY = event.target.offsetTop - (initialStampSideLength * stamp.scale - initialStampSideLength) / 2;
        let absoluteClickXWithScale = stampOffsetX + mouseOffsetXWithScale;
        let absoluteClickYWithScale = stampOffsetY + mouseOffsetYWithScale;
        let currentOrder = null;
        let lowerOrder = null;
        let lowerOrderElem;
        let absoluteStampCenterWithOffsets = that.stampCenter(initialStampSideLength, stamp);
        console.log('stamp ', stamp);
        let rotatedClickInitial;
        let initialRotatedClickWithOffsets;
        // rotate point depend on stamp type
        if (stamp.type === 'static') {
          rotatedClickInitial = geometry.rotatePoint(absoluteClickXWithScale, absoluteClickYWithScale, absoluteStampCenterWithOffsets.x, absoluteStampCenterWithOffsets.y, 360 - stamp.rotate);
          initialRotatedClickWithOffsets = {
            x: rotatedClickInitial.x,
            y: rotatedClickInitial.y
          };
        } else if (stamp.type === 'eyes' || stamp.type === 'mouth') {
          rotatedClickInitial = geometry.rotatePoint(absoluteClickXWithScale, absoluteClickYWithScale, absoluteStampCenterWithOffsets.x, absoluteStampCenterWithOffsets.y, 360 + stamp.rotate);
          initialRotatedClickWithOffsets = {
            x: rotatedClickInitial.x,
            y: rotatedClickInitial.y
          };
          console.error('eyes');
        }
        console.warn(initialRotatedClickWithOffsets.x);
        console.warn(initialRotatedClickWithOffsets.y);
        computedStamps.forEach(function (compStamp) {
          let range;
          if (compStamp.type === 'static') {
            range = that.getStampsRange(compStamp.staticOffset, initialStampSideLength, compStamp.scale);
          } else if (compStamp.type === 'eyes' || compStamp.type === 'mouth') {
            range = that.getStampsRange(compStamp.leftTopStampPoint, initialStampSideLength, compStamp.scale);
          }
          let currentStampCenterWithOffsets = that.stampCenter(initialStampSideLength, compStamp);
          // right click angle
          let rotatedClick = geometry.rotatePoint(initialRotatedClickWithOffsets.x, initialRotatedClickWithOffsets.y, currentStampCenterWithOffsets.x, currentStampCenterWithOffsets.y, compStamp.rotate);
          let rotatedClickWithStampOffsets = {
            x: rotatedClick.x,
            y: rotatedClick.y
          };
          if (range && range.rangeX.start <= rotatedClickWithStampOffsets.x && rotatedClickWithStampOffsets.x <= range.rangeX.end && range.rangeY.start <= rotatedClickWithStampOffsets.y && rotatedClickWithStampOffsets.y <= range.rangeY.end) {
            if (currentOrder === null) {
              currentOrder = stamp.order;
            }
            if (stamp !== compStamp && currentOrder > compStamp.order) {
              currentOrder = compStamp.order;
              lowerOrder = parseInt(currentOrder, 10);
              lowerOrderElem = compStamp;
            } else if (compStamp.order === currentOrder) {
              lowerOrder = parseInt(currentOrder, 10);
              lowerOrderElem = compStamp;
            }
            console.log(lowerOrderElem);
          }
        });
        if (lowerOrderElem) {
          lowerOrderElem.order = stamp.order + 1;
          scaleResizeAvailableIndex = lowerOrderElem.pivot_id;
          if (lowerOrderElem.type === 'eyes') {
            currentStampType = 'eyes';
          } else if (lowerOrderElem.type === 'mouth') {
            currentStampType = 'mouth';
          } else if (lowerOrderElem.type === 'static') {
            currentStampType = 'static';
          } else if (lowerOrderElem.type === 'frame') {
            currentStampType = 'frame';
          }
          story.data.content.forEach((item, i) => {
            if (item.pivot_id === lowerOrderElem.pivot_id) {
              stampIndex = i;
            }
          });
          story.data.content[stampIndex].order = lowerOrderElem.order;
        }
      }
    }
    return {
      stampIndex,
      scaleResizeAvailableIndex,
      currentStampType
    };
  },
  stampCenter(stampSideLength, stamp) {
    let currentStampCenter = stampSideLength * stamp.scale / 2;
    let currentStampOffsetX;
    let currentStampOffsetY;
    if (stamp.type === 'static') {
      currentStampOffsetX = stamp.staticOffset.x;
      currentStampOffsetY = stamp.staticOffset.y;
    } else if (stamp.type === 'eyes' || stamp.type === 'mouth') {
      currentStampOffsetX = stamp.leftTopStampPoint.x;
      currentStampOffsetY = stamp.leftTopStampPoint.y;
    }
    let stampOffsetWithScaleX = currentStampOffsetX - (stampSideLength * stamp.scale - stampSideLength) / 2;
    let stampOffsetWithScaleY = currentStampOffsetY - (stampSideLength * stamp.scale - stampSideLength) / 2;
    return {
      x: stampOffsetWithScaleX + currentStampCenter,
      y: stampOffsetWithScaleY + currentStampCenter
    };
  },
  sendPhotoToBackend(http, host, storyId, formData) {
    return http.post(`${host}/cp/stories/${storyId}/content`,
      formData, {
        headers: {
          "Content-Type": 'multipart/form-data'
        }
      });
  },
  highlightDefaultStamp(story, currentStamp) {
    let stampIndex = null;
    let highLightIndex = null;
    story.data.content.forEach((item, i) => {
      if (item.pivot_id === currentStamp.pivot_id) {
        stampIndex = i;
        highLightIndex = item.pivot_id;
      }
    });
    return {stampIndex, highLightIndex};
  },
  createDownloadImageData(that, initialStampSideLength, computedStamps) {
    that.$emit('download-data', {
      size: initialStampSideLength,
      stamps: computedStamps
    });
  },
  createCanvasStory(canvas, photoUrl, photoSize, stampSize, stamps, link) {
    let that = this;
    let promiseArray = [];
    let context = canvas.getContext('2d');
    canvas.width = photoSize.width;
    canvas.height = photoSize.height;
    let canvasStamps = stamps.map(function (stamp) {
      console.log('stamp ', stamp);
      let scaledSize;
      let scaleDiff;
      let margins;
      let rotate;
      let stampUrl;
      let stampOrder;
      if (stamp.type === 'eyes' || stamp.type === 'mouth' && stamp.leftTopStampPoint) {
        console.log('leftTopStampPoint ', stamp.leftTopStampPoint.x);
        scaledSize = stampSize * stamp.scale;
        scaleDiff = (scaledSize - stampSize) / 2;
        margins = {
          x: stamp.leftTopStampPoint.x - scaleDiff,
          y: stamp.leftTopStampPoint.y - scaleDiff
        };
        rotate = stamp.rotate;
        stampUrl = stamp.url;
        stampOrder = stamp.order;
      } else if (stamp.staticOffset && stamp.type === 'static') {
        scaledSize = stampSize * stamp.scale;
        scaleDiff = (scaledSize - stampSize) / 2;
        console.log('staticOffset ', stamp.staticOffset.x);
        margins = {
          x: stamp.staticOffset.x - scaleDiff,
          y: stamp.staticOffset.y - scaleDiff
        };
        rotate = stamp.rotate;
        stampUrl = stamp.url;
        stampOrder = stamp.order;
      } else if (stamp.type === 'frame') {
        scaledSize = photoSize.width;
        scaleDiff = 0;
        rotate = 0;
        stampUrl = stamp.url;
        stampOrder = 0;
        if (stamp.position === 'b') {
          margins = {
            x: 0,
            y: photoSize.height - 270
          };
        } else if (stamp.position === 't') {
          margins = {
            x: 0,
            y: 0
          };
        }
      }
      return {
        scaledSize,
        scaleDiff,
        margins,
        stampUrl,
        stampOrder,
        rotate,
        type: stamp.type
      };
    });
    canvasStamps.sort(function (a, b) {
      return a.stampOrder - b.stampOrder;
    });
    console.log('canvasStamps ', canvasStamps);
    // create background
    let background = new Image(photoSize.width, photoSize.height);
    background.src = photoUrl;
    context.drawImage(background, 0, 0);
    canvasStamps.forEach(function (item) {
      // let img = new Image(item.scaledSize, item.scaledSize, photoSize.width, photoSize.height);
      let img = new Image();
      img.src = item.stampUrl;
      context.save();
      context.translate(item.margins.x + (item.scaledSize / 2), item.margins.y + (item.scaledSize / 2));
      if (item.type === 'static') {
        context.rotate(-item.rotate * Math.PI / 180);
      } else {
        context.rotate(item.rotate * Math.PI / 180);
      }
      context.translate(-(item.margins.x + (item.scaledSize / 2)), -(item.margins.y + (item.scaledSize / 2)));
      context.drawImage(img, item.margins.x, item.margins.y, item.scaledSize, item.scaledSize);
      context.restore();
      promiseArray.push(new Promise(function (resolve, reject) {
        img.onload = function () {
          resolve();
        };
        setTimeout(function () {
          reject();
        }, 4000);
      }));
    });
    return Promise.all(promiseArray).then(function (success) {
      console.log(fileSaver);
      canvas.toBlob(function (blob) {
        fileSaver.saveAs(blob, "Stickerpipe story.jpeg");
      });
    }, function (error) {
      console.log('error ', error);
    });
  },
  loaderService(loader, loaderStatus) {
    if (loaderStatus) {
      loader.style.display = 'block';
    } else {
      loader.style.display = 'none';
    }
  }
};

export default previewServices;



// WEBPACK FOOTER //
// ./src/js/preview-services.js